import axios from 'axios';
import { API_URI } from './../consts';

const getPartners = (initDate, finishDate, recruiterId, clientId, ceco) => {
    return axios.get(`${API_URI}search-operators?initDate=${initDate}&finishDate=${finishDate}&recruiterId=${recruiterId}&clientId=${clientId}&ceco=${ceco}`);
};

const getDetailsPayment = (initDate, finishDate, partnerId, clientId, ceco) => {
    return axios.get(`${API_URI}details-payment?initDate=${initDate}&finishDate=${finishDate}&partnerId=${partnerId}&clientId=${clientId}&ceco=${ceco}`);
};

const getCeco = (initDate, finishDate, clientId) => {
    return axios.get(`${API_URI}cecos-available?initDate=${initDate}&finishDate=${finishDate}&clientId=${clientId}`);
}

const updateApprovePayment = (idPartner, idList, status) => {
    return axios.post(`${API_URI}status-payment`, {
        idPartner,
        idList,
        status
    });
};

const updateRecruiterPartner = (idPartner, idRecruiter) => {
    return axios.put(`/api/personal/${idPartner}/recruiter-update`, {
        idRecruiter
    });
};

const createPayroll = (recruiterId, initDate, finishDate, inPayroll, isApproved) => {
    return axios.post(`${API_URI}create-payroll`, {
        recruiterId,
        initDate,
        finishDate,
        inPayroll,
        isApproved
    })
};

const createVoucherPayroll = (data) => {
    return axios.post(`${API_URI}create-voucher`, data)
};

const getPayrolls = (recruiterId, selectedStartDate, selectedFinalDate) => {
    return axios.get(`${API_URI}search-payrolls?initDate=${selectedStartDate}&finishDate=${selectedFinalDate}&recruiterId=${recruiterId}`)
};

const deletePayroll = (payrollId) => {
    return axios.delete(`${API_URI}delete-payroll/${payrollId}`)
};

const updateDtoAddReason = (partnerId, listId, value, reason) => {
    return axios.put(`${API_URI}update-payment`, {
        partnerId,
        listId,
        value,
        reason
    })
};

const updateBasePriceServices = (partnerId) => {
    return axios.post(`${API_URI}base-price-services`, {
        partnerId
    })
};

export default {
    getPartners,
    getDetailsPayment,
    getCeco,
    updateApprovePayment,
    updateRecruiterPartner,
    createPayroll,
    getPayrolls,
    deletePayroll,
    createVoucherPayroll,
    updateDtoAddReason,
    updateBasePriceServices
};


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/services/paymentPartnersService.js